import { Button } from "@mui/material";

export default function ResetFilters({ resetAll, sx }) {
  return (
    <Button
      variant="outlined"
      color="secondary"
      onClick={resetAll}
      sx={sx}   // apply shared styling from App.js
    >
      RESET FILTERS
    </Button>
  );
}
